module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__on_disconnect__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_push_key__ = __webpack_require__(17);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ThenableReference; });




var Reference = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](Reference, _super);
    function Reference(path, db) {
        return _super.call(this, path, db) || this;
    }
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this._path.key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            var parent = this._path.parent;
            return parent ? new Reference(parent, this._db) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return new Reference('/', this._db);
        },
        enumerable: true,
        configurable: true
    });
    Reference.prototype.child = function (path) {
        return new Reference(this._path.child(path), this._db);
    };
    Reference.prototype.set = function (value) {
        var _this = this;
        if (typeof value === 'undefined') {
            throw new Error('Query.set: no value specified');
        }
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'set', [_this._path.toString(), value]);
        });
    };
    Reference.prototype.remove = function () {
        return this.set(null);
    };
    Reference.prototype.push = function (value) {
        var pushKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_push_key__["a" /* generatePushKey */])();
        if (typeof value === 'undefined') {
            return this.child(pushKey);
        }
        var thenableRef = new ThenableReference(this._path.child(pushKey), this._db);
        thenableRef.set(value);
        return thenableRef;
    };
    Reference.prototype.setPriority = function (priority) {
        var newRef = new Reference(this._path.child('.priority', true), this._db);
        return newRef.set(priority);
    };
    Reference.prototype.setWithPriority = function (value, priority) {
        return this.set({
            '.value': value,
            '.priority': priority,
        });
    };
    Reference.prototype.transaction = function () {
        // TODO: implement this... but how? It might not be possible.
        throw new Error('Transactions are not supported yet. Sorry!');
    };
    Reference.prototype.update = function (value) {
        var _this = this;
        if (typeof value === 'undefined') {
            throw new Error('Query.update: no value specified');
        }
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'update', [_this._path.toString(), value]);
        });
    };
    Reference.prototype.onDisconnect = function () {
        return new __WEBPACK_IMPORTED_MODULE_2__on_disconnect__["a" /* OnDisconnect */](this._db, this._path.toString());
    };
    return Reference;
}(__WEBPACK_IMPORTED_MODULE_1__query__["a" /* Query */]));

var ThenableReference = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](ThenableReference, _super);
    function ThenableReference() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThenableReference.prototype.set = function (value) {
        this._promise = _super.prototype.set.call(this, value);
        return this._promise;
    };
    ThenableReference.prototype.then = function (onfulfilled, onrejected) {
        return this._promise.then(onfulfilled, onrejected);
    };
    ThenableReference.prototype.catch = function (onrejected) {
        return this._promise.catch(onrejected);
    };
    return ThenableReference;
}(Reference));



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cordova_exec__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cordova_exec___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cordova_exec__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_cordova_exec___default.a; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getValueType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isInteger; });
// declare module 'cordova/exec' {
//     function exec(success: SuccessCallback,
//                                error: ErrorCallback,
//                                plugin: string,
//                                action: string,
//                                args: any[]): void;
//     export = exec;
// }


function getValueType(value) {
    if (value === void 0) {
        return 'undefined';
    }
    if (value === null) {
        return 'null';
    }
    var type = typeof value;
    if ((type === 'number') || (type === 'string') || (type === 'boolean') || (type === 'function')) {
        return type;
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    if (type === 'object') {
        return 'object';
    }
    return 'unknown';
}
var isInteger = Number.isInteger || function (value) {
    return (typeof value === 'number') && isFinite(value) && Math.floor(value) === value;
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
};

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), q = [], c, i;
    return i = { next: verb("next"), "throw": verb("throw"), "return": verb("return") }, i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { return function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]), next(); }); }; }
    function next() { if (!c && q.length) resume((c = q.shift())[0], c[1]); }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(c[3], e); } }
    function step(r) { r.done ? settle(c[2], r) : r.value[0] === "yield" ? settle(c[2], { value: r.value[1], done: false }) : Promise.resolve(r.value[1]).then(r.value[0] === "delegate" ? delegate : fulfill, reject); }
    function delegate(r) { step(r.done ? r : { value: ["yield", r.value], done: false }); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { c = void 0, f(v), next(); }
};

function __asyncDelegator(o) {
    var i = { next: verb("next"), "throw": verb("throw", function (e) { throw e; }), "return": verb("return", function (v) { return { value: v, done: true }; }) };
    return o = __asyncValues(o), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { return function (v) { return { value: ["delegate", (o[n] || f).call(o, v)], done: false }; }; }
};

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Analytics; });
var Analytics = (function () {
    function Analytics(_app) {
        this._app = _app;
    }
    Analytics.getInstance = function (app) {
        if (!this._instance) {
            this._instance = new Analytics(app);
        }
        return this._instance;
    };
    Analytics.prototype._exec = function (success, error, action, args) {
        this._app._execWithoutName(success, error, "analytics_" + action, args);
    };
    Analytics.prototype.logEvent = function (name, params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'logEvent', [name, params]);
        });
    };
    Analytics.prototype.setScreenName = function (name) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setScreenName', [name]);
        });
    };
    Analytics.prototype.setUserId = function (id) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setUserId', [id]);
        });
    };
    Analytics.prototype.setUserProperty = function (name, value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setUserProperty', [name, value]);
        });
    };
    return Analytics;
}());



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__providers__ = __webpack_require__(16);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__providers__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__providers__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__providers__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__providers__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__providers__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__user__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_info__ = __webpack_require__(5);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__user_info__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });


var Auth = (function () {
    /**
     * @internal
     */
    function Auth(app) {
        this.app = app;
        this._currentUser = null;
        this._authListenerId = 0;
        this._authListeners = {};
    }
    Auth.prototype._exec = function (success, error, action, args) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* exec */])(success, error, 'Firebase', "auth_" + action, [this.app.name].concat(args));
    };
    Object.defineProperty(Auth.prototype, "currentUser", {
        get: function () {
            return this._currentUser;
        },
        enumerable: true,
        configurable: true
    });
    Auth.prototype.applyActionCode = function (code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'applyActionCode', [code]);
        });
    };
    Auth.prototype.checkActionCode = function (code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (email) {
                resolve({ data: { email: email } });
            };
            _this._exec(success, reject, 'checkActionCode', [code]);
        });
    };
    Auth.prototype.createUserWithEmailAndPassword = function (email, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (internalUserInfo) {
                resolve(new __WEBPACK_IMPORTED_MODULE_1__user__["a" /* User */](_this, internalUserInfo));
            };
            _this._exec(success, reject, 'createUserWithEmailAndPassword', [email, password]);
        });
    };
    Auth.prototype.fetchProvidersForEmail = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'fetchProvidersForEmail', [email]);
        });
    };
    Auth.prototype.onAuthStateChanged = function (callback, errorFn, completeFn) {
        var _this = this;
        var listenerId = this._authListenerId++;
        this._authListeners[listenerId] = { callback: callback, errorFn: errorFn, completeFn: completeFn };
        if (Object.keys(this._authListeners).length === 1) {
            this._attachAuthStateChangeListener();
        }
        return function () { return _this._removeAuthStateListener(listenerId); };
    };
    Auth.prototype.signInAnonymously = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (internalUserInfo) {
                resolve(new __WEBPACK_IMPORTED_MODULE_1__user__["a" /* User */](_this, internalUserInfo));
            };
            _this._exec(success, reject, 'signInAnonymously', []);
        });
    };
    Auth.prototype.signInWithCredential = function (credential) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'signInWithCredential', [credential]);
        });
    };
    Auth.prototype.signInWithCustomToken = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (internalUserInfo) {
                resolve(new __WEBPACK_IMPORTED_MODULE_1__user__["a" /* User */](_this, internalUserInfo));
            };
            _this._exec(success, reject, 'signInWithCustomToken', [token]);
        });
    };
    Auth.prototype.signInWithEmailAndPassword = function (email, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (internalUserInfo) {
                resolve(new __WEBPACK_IMPORTED_MODULE_1__user__["a" /* User */](_this, internalUserInfo));
            };
            _this._exec(success, reject, 'signInWithEmailAndPassword', [email, password]);
        });
    };
    Auth.prototype.signOut = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'signOut', []);
        });
    };
    Auth.prototype.sendPasswordResetEmail = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'sendPasswordResetEmail', [email]);
        });
    };
    Auth.prototype.verifyPasswordResetCode = function (code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'verifyPasswordResetCode', [code]);
        });
    };
    Auth.prototype.confirmPasswordReset = function (code, newPassword) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'confirmPasswordReset', [code, newPassword]);
        });
    };
    Auth.prototype._removeAuthStateListener = function (listenerId) {
        if (this._authListeners[listenerId]) {
            var listener = this._authListeners[listenerId];
            if (typeof listener.completeFn === 'function') {
                listener.completeFn();
            }
            delete this._authListeners[listenerId];
            if (Object.keys(this._authListeners).length === 0) {
                this._detachAuthStateChangeListener();
            }
        }
    };
    Auth.prototype._attachAuthStateChangeListener = function () {
        var _this = this;
        var callback = function (internalUserInfo) {
            _this._currentUser = new __WEBPACK_IMPORTED_MODULE_1__user__["a" /* User */](_this, internalUserInfo);
            for (var listenerId in _this._authListeners) {
                _this._authListeners[listenerId].callback(_this._currentUser);
            }
        };
        var error = function (reason) {
            for (var listenerId in _this._authListeners) {
                _this._authListeners[listenerId].errorFn(reason);
            }
        };
        this._exec(callback, error, 'addAuthStateListener', []);
    };
    Auth.prototype._detachAuthStateChangeListener = function () {
        var error = function (reason) {
            throw new Error('Failed detaching auth state change listener:' + reason);
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* exec */])(function () {
        }, error, 'Firebase', 'auth_removeAuthStateListener', []);
    };
    return Auth;
}());






/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserInfo; });
var UserInfo = (function () {
    /**
     * @internal
     */
    function UserInfo(_internalUser) {
        this._internalUser = _internalUser;
    }
    Object.defineProperty(UserInfo.prototype, "uid", {
        get: function () {
            return this._internalUser.uid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "displayName", {
        get: function () {
            return this._internalUser.displayName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "email", {
        get: function () {
            return this._internalUser.email;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "photoURL", {
        get: function () {
            return this._internalUser.photoURL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserInfo.prototype, "providerId", {
        get: function () {
            return this._internalUser.providerId;
        },
        enumerable: true,
        configurable: true
    });
    return UserInfo;
}());



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_info__ = __webpack_require__(5);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });



var User = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */](User, _super);
    /**
     * @internal
     */
    function User(_auth, internalUser) {
        var _this = _super.call(this, internalUser) || this;
        _this._auth = _auth;
        _this._updateProviderData();
        return _this;
    }
    User.prototype._exec = function (success, error, action, args) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* exec */])(success, error, 'Firebase', "auth_user_" + action, [this._auth.app.name].concat(args));
    };
    Object.defineProperty(User.prototype, "emailVerified", {
        get: function () {
            return this._internalUser.emailVerified;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isAnonymous", {
        get: function () {
            return this._internalUser.isAnonymous;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "providerData", {
        get: function () {
            // Return a copy of the providerData array to prevent accidental
            // modifications to the internal representation.
            return this._providerData.slice();
        },
        enumerable: true,
        configurable: true
    });
    User.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'delete', [_this.uid]);
        });
    };
    User.prototype.getToken = function (forceRefresh) {
        var _this = this;
        if (forceRefresh === void 0) { forceRefresh = false; }
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getToken', [_this.uid, forceRefresh]);
        });
    };
    User.prototype.reload = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var callback = function (internalUser) {
                _this._internalUser = internalUser;
                _this._updateProviderData();
                resolve();
            };
            _this._exec(callback, reject, 'reload', [_this.uid]);
        });
    };
    User.prototype.sendEmailVerification = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'sendEmailVerification', [_this.uid]);
        });
    };
    User.prototype.updateEmail = function (newEmail) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'updateEmail', [_this.uid, newEmail]);
        });
    };
    User.prototype.updatePassword = function (newPassword) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'updatePassword', [_this.uid, newPassword]);
        });
    };
    User.prototype.updateProfile = function (profile) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _profile = {};
            var hasDisplayName = false;
            var hasPhotoURL = false;
            if (profile.displayName !== void 0) {
                hasDisplayName = true;
                _profile.displayName = profile.displayName;
            }
            if (profile.photoURL !== void 0) {
                hasPhotoURL = true;
                _profile.photoURL = profile.photoURL;
            }
            if (!hasDisplayName && !hasPhotoURL) {
                reject('You need to specify at least one of displayName or photoURL');
                return;
            }
            var callback = function () {
                if (hasDisplayName) {
                    _this._internalUser.displayName = profile.displayName;
                }
                if (hasPhotoURL) {
                    _this._internalUser.photoURL = profile.photoURL;
                }
                resolve();
            };
            _this._exec(callback, reject, 'updateProfile', [_this.uid, _profile]);
        });
    };
    User.prototype.link = function (credential) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'link', [_this.uid, credential]);
        });
    };
    User.prototype.unlink = function (providerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var callback = function (internalUser) {
                _this._internalUser = internalUser;
                _this._updateProviderData();
                resolve();
            };
            _this._exec(callback, reject, 'unlink', [_this.uid, providerId]);
        });
    };
    User.prototype.reauthenticate = function (credential) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'reauthenticate', [_this.uid, credential]);
        });
    };
    User.prototype.toJSON = function () {
        return JSON.parse(JSON.stringify(this._internalUser));
    };
    User.prototype._updateProviderData = function () {
        var _this = this;
        this._providerData = [];
        this._internalUser.providerData.forEach(function (providerUser) {
            _this._providerData.push(new __WEBPACK_IMPORTED_MODULE_2__user_info__["a" /* UserInfo */](providerUser));
        });
    };
    return User;
}(__WEBPACK_IMPORTED_MODULE_2__user_info__["a" /* UserInfo */]));



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reference__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_path__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataSnapshot; });


var DataSnapshot = (function () {
    function DataSnapshot(_db, _path, _value, key) {
        if (_value === void 0) { _value = null; }
        this._db = _db;
        this._path = _path;
        this._value = _value;
        if (typeof key === 'string') {
            this._path = this._path.child(key);
        }
    }
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this._path.key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return new __WEBPACK_IMPORTED_MODULE_0__reference__["a" /* Reference */](this._path, this._db);
        },
        enumerable: true,
        configurable: true
    });
    DataSnapshot.prototype.child = function (path) {
        var pathParts = __WEBPACK_IMPORTED_MODULE_1__utils_path__["a" /* Path */].getParts(path);
        var value = this._value;
        while (pathParts.length) {
            var childKey = pathParts.shift();
            if ((typeof value === 'undefined') || (value === null) || !value.hasOwnProperty(childKey)) {
                value = null;
                break;
            }
            value = value[childKey];
        }
        return new DataSnapshot(this._db, this._path.child(path), value);
    };
    DataSnapshot.prototype.exists = function () {
        return (typeof this._value !== 'undefined') && (this._value !== null);
    };
    DataSnapshot.prototype.hasChild = function (path) {
        var pathParts = __WEBPACK_IMPORTED_MODULE_1__utils_path__["a" /* Path */].getParts(path);
        var value = this._value;
        while (pathParts.length) {
            var childKey = pathParts.shift();
            if ((typeof value === 'undefined') || (value === null) || !value.hasOwnProperty(childKey)) {
                return false;
            }
            value = value[childKey];
        }
        return ((typeof value !== 'undefined') && (value !== null));
    };
    DataSnapshot.prototype.hasChildren = function () {
        var _this = this;
        if (!this._isObjectValue()) {
            return false;
        }
        return Object.keys(this._value)
            .some(function (key) { return (typeof _this._value[key] !== 'undefined') && (_this._value[key] !== null); });
    };
    DataSnapshot.prototype.numChildren = function () {
        var _this = this;
        if (!this._isObjectValue()) {
            return 0;
        }
        return Object.keys(this._value)
            .find(function (key) { return (typeof _this._value[key] !== 'undefined') && (_this._value[key] !== null); })
            .length;
    };
    DataSnapshot.prototype.val = function () {
        return this._value;
    };
    DataSnapshot.prototype.forEach = function (childFn) {
        // TODO: loop the child keys in the same order that was specified in the query that generated this snapshot
        if (!this._isObjectValue()) {
            return false;
        }
        var keys = Object.keys(this._value);
        for (var i = 0, l = keys.length; i < l; i++) {
            if (childFn(this.child(keys[i]))) {
                return true;
            }
        }
        return false;
    };
    DataSnapshot.prototype._isObjectValue = function () {
        if ((typeof this._value === 'undefined') || (this._value === null) || Array.isArray(this._value)) {
            return false;
        }
        return (typeof this._value === 'object');
    };
    return DataSnapshot;
}());



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reference__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_snapshot__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__reference__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__data_snapshot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__query__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__reference__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__on_disconnect__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__on_disconnect__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Database; });
/* unused harmony export ServerValue */


var Database = (function () {
    /**
     * @internal
     */
    function Database(app) {
        this.app = app;
        /**
         * @internal
         */
        this._listeners = {};
        /**
         * @internal
         */
        this._listenerCounter = 1;
    }
    /**
     * @internal
     */
    Database.prototype._exec = function (success, error, action, args) {
        this.app._exec(success, error, "database_" + action, args);
    };
    Database.prototype.ref = function (path) {
        return new __WEBPACK_IMPORTED_MODULE_0__reference__["a" /* Reference */](path, this);
    };
    Database.prototype.goOffline = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'goOffline');
        });
    };
    Database.prototype.goOnline = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'goOnline');
        });
    };
    Database.prototype.setPersistenceEnabled = function (isEnabled) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'setPersistenceEnabled', [isEnabled]);
        });
    };
    return Database;
}());

var ServerValue = {
    TIMESTAMP: {
        '.sv': 'timestamp',
    },
};






/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OnDisconnect; });
var OnDisconnect = (function () {
    function OnDisconnect(_db, _path) {
        this._db = _db;
        this._path = _path;
    }
    OnDisconnect.prototype._exec = function (success, error, action, args) {
        this._db._exec(success, error, "onDisconnect_" + action, args);
    };
    OnDisconnect.prototype.set = function (value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'set', [_this._path, value]);
        });
    };
    OnDisconnect.prototype.remove = function () {
        return this.set(null);
    };
    OnDisconnect.prototype.update = function (value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'update', [_this._path, value]);
        });
    };
    OnDisconnect.prototype.cancel = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'cancel', [_this._path]);
        });
    };
    OnDisconnect.prototype.setWithPriority = function (value, priority) {
        return this.set({
            '.value': value,
            '.priority': priority,
        });
    };
    return OnDisconnect;
}());



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_path__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reference__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_snapshot__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Query; });





var Query = (function () {
    function Query(pathOrQuery, _dbOrOptions) {
        if (pathOrQuery instanceof Query) {
            this._path = pathOrQuery._path;
            this._db = pathOrQuery._db;
            this._options = _dbOrOptions;
            return;
        }
        this._path = (pathOrQuery instanceof __WEBPACK_IMPORTED_MODULE_2__utils_path__["a" /* Path */]) ? pathOrQuery : new __WEBPACK_IMPORTED_MODULE_2__utils_path__["a" /* Path */](pathOrQuery);
        this._db = _dbOrOptions;
        this._options = {
            _hasOrder: false,
            startAt: {
                value: void 0,
                valueType: void 0,
                key: void 0,
            },
            endAt: {
                value: void 0,
                valueType: void 0,
                key: void 0,
            },
            equalTo: {
                value: void 0,
                valueType: void 0,
                key: void 0,
            },
            limitToFirst: void 0,
            limitToLast: void 0,
            orderByKey: void 0,
            orderByChild: void 0,
            orderByPriority: false,
            orderByValue: false,
        };
    }
    Query.prototype._exec = function (success, error, action, args) {
        this._db._exec(success, error, action, args);
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return new __WEBPACK_IMPORTED_MODULE_3__reference__["a" /* Reference */](this._path, this._db);
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.startAt = function (value, key) {
        if (this._options.startAt !== void 0) {
            throw new Error('Query.startAt: either startAt or equalTo has already been set');
        }
        var valueType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getValueType */])(value);
        if ((valueType !== 'number') && (valueType !== 'string') && (valueType !== 'boolean') && (valueType !== 'null')) {
            throw new Error("Query.startAt: value must be either a number, a string, or a boolean. \"" + valueType + "\" is not a valid type.");
        }
        if (key !== void 0) {
            if (typeof key !== 'string') {
                throw new Error("Query.startAt: key must be either a string");
            }
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { startAt: { value: value, valueType: valueType, key: key } }));
    };
    Query.prototype.endAt = function (value, key) {
        if (this._options.endAt !== void 0) {
            throw new Error('Query.endAt: either endAt or equalTo has already been set');
        }
        var valueType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getValueType */])(value);
        if ((valueType !== 'number') && (valueType !== 'string') && (valueType !== 'boolean') && (valueType !== 'null')) {
            throw new Error("Query.endAt: value must be either a number, a string, or a boolean. \"" + valueType + "\" is not a valid type.");
        }
        if (key !== void 0) {
            if (typeof key !== 'string') {
                throw new Error("Query.endAt: key must be either a string");
            }
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { endAt: { value: value, valueType: valueType, key: key } }));
    };
    Query.prototype.equalTo = function (value, key) {
        if ((this._options.startAt !== void 0) || (this._options.endAt !== void 0)) {
            throw new Error('Query.equalTo: either startAt, endAt, or equalTo has already been set');
        }
        var valueType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getValueType */])(value);
        if ((valueType !== 'number') && (valueType !== 'string') && (valueType !== 'boolean') && (valueType !== 'null')) {
            throw new Error("Query.equalTo: value must be either a number, a string, or a boolean. \"" + valueType + "\" is not a valid type.");
        }
        if (key !== void 0) {
            if (typeof key !== 'string') {
                throw new Error("Query.equalTo: key must be either a string");
            }
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { equalTo: { value: value, valueType: valueType, key: key } }));
    };
    Query.prototype.limitToFirst = function (limit) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isInteger */])(limit)) {
            throw new Error('Query.limitToFirst: value is not an integer');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { limitToFirst: [limit] }));
    };
    Query.prototype.limitToLast = function (limit) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* isInteger */])(limit)) {
            throw new Error('Query.limitToLast: value is not an integer');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { limitToLast: [limit] }));
    };
    Query.prototype.orderByKey = function () {
        if (this._options.hasOrder) {
            throw new Error('Query.orderByKey: order has already been set');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { hasOrder: true, orderByKey: true }));
    };
    Query.prototype.orderByChild = function (path) {
        if (this._options.hasOrder) {
            throw new Error('Query.orderByChild: order has already been set');
        }
        if (typeof path !== 'string') {
            throw new Error('Query.orderByChild: path needs to be a string');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { hasOrder: true, orderByChild: [path] }));
    };
    Query.prototype.orderByPriority = function () {
        if (this._options.hasOrder) {
            throw new Error('Query.orderByPriority: order has already been set');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { hasOrder: true, orderByPriority: true }));
    };
    Query.prototype.orderByValue = function () {
        if (this._options.hasOrder) {
            throw new Error('Query.orderByValue: order has already been set');
        }
        return new Query(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __assign */]({}, this._options, { hasOrder: true, orderByValue: true }));
    };
    Query.prototype.isEqual = function (query) {
        return (this._db === query._db)
            && (this._path.isEqual(query._path))
            && (this._options.startAt.value === query._options.startAt.value)
            && (this._options.startAt.valueType === query._options.startAt.valueType)
            && (this._options.startAt.key === query._options.startAt.key)
            && (this._options.endAt.value === query._options.endAt.value)
            && (this._options.endAt.valueType === query._options.endAt.valueType)
            && (this._options.endAt.key === query._options.endAt.key)
            && (this._options.equalTo.value === query._options.equalTo.value)
            && (this._options.equalTo.valueType === query._options.equalTo.valueType)
            && (this._options.equalTo.key === query._options.equalTo.key)
            && (this._options.limitToFirst === query._options.limitToFirst)
            && (this._options.limitToLast === query._options.limitToLast)
            && (this._options.hasOrder === query._options.hasOrder)
            && (this._options.orderByKey === query._options.orderByKey)
            && (this._options.orderByChild === query._options.orderByChild)
            && (this._options.orderByPriority === query._options.orderByPriority)
            && (this._options.orderByValue === query._options.orderByValue);
    };
    Query.prototype.on = function (eventType, callback, errorFn) {
        this._attachListener(false, eventType, callback, errorFn);
        return callback;
    };
    Query.prototype.once = function (eventType, callback, errorFn) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var success = function (value) {
                if (typeof callback === 'function') {
                    callback(value);
                }
                resolve(value);
            };
            var error = function (reason) {
                if (typeof errorFn === 'function') {
                    errorFn(reason);
                }
                reject(reason);
            };
            _this._attachListener(true, eventType, success, error);
        });
    };
    Query.prototype._attachListener = function (once, eventType, callback, errorFn) {
        var _this = this;
        if (once === void 0) { once = false; }
        if (eventType === void 0) { eventType = 'value'; }
        var listenerID = String(this._db._listenerCounter++);
        this._addListener(listenerID, this._path, eventType, callback);
        var success = function (listenerEvent) {
            if (once) {
                _this._removeListener(listenerID);
            }
            var snapshot = new __WEBPACK_IMPORTED_MODULE_4__data_snapshot__["a" /* DataSnapshot */](_this._db, _this._path, listenerEvent.value, listenerEvent.key);
            callback(snapshot, listenerEvent.prevChildKey);
        };
        var error = function (reason) {
            _this._removeListener(listenerID);
            if (typeof errorFn === 'function') {
                errorFn(new Error(reason));
            }
        };
        var queryOptions = {};
        if (this._options.hasOrder) {
            if (this._options.orderByValue) {
                queryOptions.orderByValue = true;
            }
            else if (this._options.orderByPriority) {
                queryOptions.orderByPriority = true;
            }
            else if (this._options.orderByChild !== void 0) {
                queryOptions.orderByChild = this._options.orderByChild;
            }
            else if (this._options.orderByKey) {
                queryOptions.orderByKey = true;
            }
        }
        if (this._options.limitToFirst !== void 0) {
            queryOptions.limitToFirst = this._options.limitToFirst;
        }
        else if (this._options.limitToLast !== void 0) {
            queryOptions.limitToLast = this._options.limitToLast;
        }
        if (this._options.equalTo.value !== void 0) {
            queryOptions.equalTo = this._options.equalTo;
        }
        else {
            if (this._options.startAt.value !== void 0) {
                queryOptions.startAt = this._options.startAt;
            }
            if (this._options.endAt.value !== void 0) {
                queryOptions.endAt = this._options.endAt;
            }
        }
        this._exec(success, error, 'attachListener', [listenerID, once, this._path.toString(), eventType, queryOptions]);
    };
    Query.prototype.off = function (eventType, callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var listenerIDs;
            if (eventType && callback) {
                listenerIDs = [_this._getListenerID(eventType, callback)];
            }
            else {
                listenerIDs = _this._getListenerIDs(eventType, callback);
            }
            if (!listenerIDs || (listenerIDs.length === 0)) {
                resolve();
                return;
            }
            var success = function () {
                listenerIDs.forEach(function (id) { return _this._removeListener(id); });
                resolve();
            };
            _this._exec(success, reject, 'removeListeners', [listenerIDs]);
        });
    };
    Query.prototype.keepSynced = function (keepSynced) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, reject, 'keepSynced', [_this._path.toString(), keepSynced]);
        });
    };
    Query.prototype._removeListener = function (id) {
        if (id) {
            delete this._db._listeners[id];
        }
    };
    Query.prototype._addListener = function (id, path, eventType, callback) {
        this._db._listeners[id] = { path: path, eventType: eventType, callback: callback };
    };
    Query.prototype._getListenerID = function (eventType, callback) {
        var keys = Object.keys(this._db._listeners);
        for (var i = 0, l = keys.length; i < l; i++) {
            var id = keys[i];
            var listener = this._db._listeners[id];
            if ((listener.path === this._path) && (listener.eventType === eventType) && (listener.callback === callback)) {
                return id;
            }
        }
        // Not found
        return null;
    };
    Query.prototype._getListenerIDs = function (eventType, callback) {
        var keys = Object.keys(this._db._listeners);
        var ids = [];
        for (var i = 0, l = keys.length; i < l; i++) {
            var id = keys[i];
            var listener = this._db._listeners[id];
            if (listener.path.isEqual(this._path)
                && (!eventType || (listener.eventType === eventType))
                && (!callback || (listener.callback === callback))) {
                ids.push(id);
            }
        }
        return ids;
    };
    return Query;
}());



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Path; });
var Path = (function () {
    function Path(path) {
        if (path === void 0) { path = ''; }
        this._parts = typeof path === 'string' ? Path.getParts(path) : path;
    }
    Object.defineProperty(Path.prototype, "key", {
        get: function () {
            return this._parts.length ? this._parts[this._parts.length - 1] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Path.prototype, "parent", {
        get: function () {
            if (!this._parts.length)
                return null;
            return new Path(this._parts.slice(0, this._parts.length - 1));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Path.prototype, "parts", {
        get: function () {
            return this._parts.slice(0);
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.child = function (path, skipCheck) {
        if (skipCheck === void 0) { skipCheck = false; }
        return new Path(this._parts.concat(Path.getParts(path, skipCheck)));
    };
    Path.prototype.isEqual = function (otherPath) {
        return otherPath && (this.toString() === otherPath.toString());
    };
    Path.prototype.toString = function () {
        return '/' + this._parts.join('/');
    };
    Object.defineProperty(Path.prototype, "length", {
        get: function () {
            return this._parts.length;
        },
        enumerable: true,
        configurable: true
    });
    Path.getParts = function (path, skipCheck) {
        if (skipCheck === void 0) { skipCheck = false; }
        path = Path.normalize(path, skipCheck);
        if (path === '')
            return [];
        return path.split('/');
    };
    Path.normalize = function (path, skipCheck) {
        if (skipCheck === void 0) { skipCheck = false; }
        if (!skipCheck && /[\.\#\$\[\]]/.test(path)) {
            throw new Error("Invalid path: \"" + path + "\". Paths must be non-empty strings and can't contain \".\", \"#\", \"$\", \"[\", or \"]\"");
        }
        return path.replace(/\/\/+/, '/').replace(/^\//, '').replace(/\/$/, '');
    };
    return Path;
}());



/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Messaging; });
var Messaging = (function () {
    function Messaging(_app) {
        this._app = _app;
    }
    Messaging.getInstance = function (app) {
        if (!this._instance) {
            this._instance = new Messaging(app);
        }
        return this._instance;
    };
    Messaging.prototype._exec = function (success, error, action, args) {
        this._app._execWithoutName(success, error, "messaging_" + action, args);
    };
    Messaging.prototype.getToken = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getToken');
        });
    };
    Messaging.prototype.onNotificationOpen = function (callback, error) {
        this._exec(callback, error, 'onNotificationOpen');
    };
    Messaging.prototype.onTokenRefresh = function (callback, error) {
        this._exec(callback, error, 'onTokenRefresh');
    };
    Messaging.prototype.grantPermission = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'grantPermission');
        });
    };
    Messaging.prototype.hasPermission = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'hasPermission');
        });
    };
    Messaging.prototype.setBadgeNumber = function (number) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setBadgeNumber', [number]);
        });
    };
    Messaging.prototype.getBadgeNumber = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getBadgeNumber');
        });
    };
    Messaging.prototype.subscribe = function (topic) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'subscribe', [topic]);
        });
    };
    Messaging.prototype.unsubscribe = function (topic) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'unsubscribe', [topic]);
        });
    };
    return Messaging;
}());



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteConfig; });
var RemoteConfig = (function () {
    function RemoteConfig(_app) {
        this._app = _app;
    }
    RemoteConfig.getInstance = function (app) {
        if (!this._instance) {
            this._instance = new RemoteConfig(app);
        }
        return this._instance;
    };
    RemoteConfig.prototype._exec = function (success, error, action, args) {
        this._app._execWithoutName(success, error, "remoteConfig_" + action, args);
    };
    RemoteConfig.prototype.activateFetched = function (resolve, reject) {
        this._exec(resolve, reject, 'activateFetched');
    };
    RemoteConfig.prototype.fetch = function (cacheExpirationSeconds) {
        var _this = this;
        var args = [];
        if (typeof cacheExpirationSeconds === 'number') {
            args.push(cacheExpirationSeconds);
        }
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'fetch', args);
        });
    };
    RemoteConfig.prototype.getByteArray = function (key, namespace) {
        var _this = this;
        var args = [key];
        if (typeof namespace === 'string') {
            args.push(namespace);
        }
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getByteArray', args);
        });
    };
    RemoteConfig.prototype.getValue = function (key, namespace) {
        var _this = this;
        var args = [key];
        if (typeof namespace === 'string') {
            args.push(namespace);
        }
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getValue', args);
        });
    };
    RemoteConfig.prototype.getInfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'getInfo');
        });
    };
    RemoteConfig.prototype.setConfigSettings = function (settings) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setConfigSettings', [settings]);
        });
    };
    RemoteConfig.prototype.setDefaults = function (defaults, namespace) {
        var _this = this;
        var args = [defaults];
        if (typeof namespace === 'string') {
            args.push(namespace);
        }
        return new Promise(function (resolve, reject) {
            _this._exec(resolve, reject, 'setDefaults', args);
        });
    };
    return RemoteConfig;
}());



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Auth", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmailAuthProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookAuthProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GithubAuthProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GoogleAuthProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TwitterAuthProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__auth__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Database", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DataSnapshot", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Query", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThenableReference", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OnDisconnect", function() { return __WEBPACK_IMPORTED_MODULE_2__database__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Analytics", function() { return __WEBPACK_IMPORTED_MODULE_3__analytics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messaging__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Messaging", function() { return __WEBPACK_IMPORTED_MODULE_4__messaging__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remote_config__ = __webpack_require__(13);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RemoteConfig", function() { return __WEBPACK_IMPORTED_MODULE_5__remote_config__["a"]; });
/* harmony export (immutable) */ __webpack_exports__["app"] = app;
/* harmony export (immutable) */ __webpack_exports__["initializeApp"] = initializeApp;
/* harmony export (immutable) */ __webpack_exports__["auth"] = auth;
/* harmony export (immutable) */ __webpack_exports__["database"] = database;
/* harmony export (immutable) */ __webpack_exports__["analytics"] = analytics;
/* harmony export (immutable) */ __webpack_exports__["messaging"] = messaging;
/* harmony export (immutable) */ __webpack_exports__["remoteConfig"] = remoteConfig;

var apps = {};
var defaultApp;
function app(name) {
    if (name === void 0) { name = __WEBPACK_IMPORTED_MODULE_0__app__["a" /* App */].DEFAULT_NAME; }
    if (!apps.hasOwnProperty(name)) {
        throw new Error("There is no app named " + name);
    }
    return apps[name];
}
function initializeApp(options, name) {
    if (name === void 0) { name = __WEBPACK_IMPORTED_MODULE_0__app__["a" /* App */].DEFAULT_NAME; }
    if ((name === void 0) && defaultApp) {
        throw new Error('The default app has already been initialized');
    }
    var app = new __WEBPACK_IMPORTED_MODULE_0__app__["a" /* App */](options, name);
    apps[name] = app;
    if (name === __WEBPACK_IMPORTED_MODULE_0__app__["a" /* App */].DEFAULT_NAME) {
        defaultApp = app;
    }
    return app;
}
function auth() {
    if (!defaultApp) {
        initializeApp();
    }
    return defaultApp.auth();
}
function database() {
    if (!defaultApp) {
        initializeApp();
    }
    return defaultApp.database();
}
function analytics() {
    if (!defaultApp) {
        initializeApp();
    }
    return defaultApp.analytics();
}
function messaging() {
    if (!defaultApp) {
        initializeApp();
    }
    return defaultApp.messaging();
}
function remoteConfig() {
    if (!defaultApp) {
        initializeApp();
    }
    return defaultApp.remoteConfig();
}







/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messaging__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remote_config__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });






var App = (function () {
    /**
     * @internal
     */
    function App(options, _name) {
        if (options === void 0) { options = {}; }
        if (_name === void 0) { _name = App.DEFAULT_NAME; }
        var _this = this;
        this.options = options;
        this._name = _name;
        this._ready = false;
        this._whenReady = new Promise(function (resolve, reject) {
            var callback = function () {
                _this._ready = true;
                resolve();
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* exec */])(callback, reject, 'Firebase', 'initializeApp', [_name, options]);
        }).catch(function (reason) {
            console.error("Error initializing app " + _name + ":", reason);
        });
    }
    /**
     * @internal
     */
    App.prototype._exec = function (success, error, action, args) {
        var _this = this;
        if (args === void 0) { args = []; }
        this._whenReady.then(function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* exec */])(success, error, 'Firebase', action, [_this._name].concat(args)); });
    };
    /**
     * @internal
     */
    App.prototype._execWithoutName = function (success, error, action, args) {
        if (args === void 0) { args = []; }
        this._whenReady.then(function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* exec */])(success, error, 'Firebase', action, args); });
    };
    Object.defineProperty(App.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isReady", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    App.prototype.auth = function () {
        if (!this._authInstance) {
            this._authInstance = new __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* Auth */](this);
        }
        return this._authInstance;
    };
    App.prototype.database = function () {
        if (!this._databaseInstance) {
            this._databaseInstance = new __WEBPACK_IMPORTED_MODULE_2__database__["a" /* Database */](this);
        }
        return this._databaseInstance;
    };
    // storage(url?: string): Storage {
    //   if (!this._storageInstance) {
    //     this._storageInstance = new Storage(this, url);
    //   }
    //   return this._storageInstance;
    // }
    App.prototype.analytics = function () {
        if (this._name !== App.DEFAULT_NAME) {
            throw new Error('You can only use Analytics on the default app');
        }
        return __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* Analytics */].getInstance(this);
    };
    App.prototype.messaging = function () {
        if (this._name !== App.DEFAULT_NAME) {
            throw new Error('You can only use Messaging on the default app');
        }
        return __WEBPACK_IMPORTED_MODULE_3__messaging__["a" /* Messaging */].getInstance(this);
    };
    App.prototype.remoteConfig = function () {
        if (this._name !== App.DEFAULT_NAME) {
            throw new Error('You can only use RemoteConfig on the default app');
        }
        return __WEBPACK_IMPORTED_MODULE_5__remote_config__["a" /* RemoteConfig */].getInstance(this);
    };
    App.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._exec(function () { return resolve(); }, function (reason) { return reject(reason); }, 'deleteApp');
        });
    };
    return App;
}());

App.DEFAULT_NAME = '[DEFAULT]';


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailAuthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FacebookAuthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GithubAuthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GoogleAuthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TwitterAuthProvider; });
var EmailAuthProvider = (function () {
    function EmailAuthProvider() {
    }
    EmailAuthProvider.credential = function (email, password) {
        return ({
            provider: this.PROVIDER_ID,
            email: email,
            password: password
        });
    };
    Object.defineProperty(EmailAuthProvider.prototype, "providerId", {
        get: function () {
            return EmailAuthProvider.PROVIDER_ID;
        },
        enumerable: true,
        configurable: true
    });
    return EmailAuthProvider;
}());

EmailAuthProvider.PROVIDER_ID = 'password';
var FacebookAuthProvider = (function () {
    function FacebookAuthProvider() {
    }
    FacebookAuthProvider.credential = function (token) {
        return ({
            provider: this.PROVIDER_ID,
            token: token
        });
    };
    Object.defineProperty(FacebookAuthProvider.prototype, "providerId", {
        get: function () {
            return FacebookAuthProvider.PROVIDER_ID;
        },
        enumerable: true,
        configurable: true
    });
    return FacebookAuthProvider;
}());

FacebookAuthProvider.PROVIDER_ID = 'facebook.com';
var GithubAuthProvider = (function () {
    function GithubAuthProvider() {
    }
    GithubAuthProvider.credential = function (token) {
        return ({
            provider: this.PROVIDER_ID,
            token: token
        });
    };
    Object.defineProperty(GithubAuthProvider.prototype, "providerId", {
        get: function () {
            return GithubAuthProvider.PROVIDER_ID;
        },
        enumerable: true,
        configurable: true
    });
    return GithubAuthProvider;
}());

GithubAuthProvider.PROVIDER_ID = 'github.com';
var GoogleAuthProvider = (function () {
    function GoogleAuthProvider() {
    }
    GoogleAuthProvider.credential = function (idToken, accessToken) {
        if ((idToken === void 0) && (accessToken === void 0)) {
            throw new Error('Both idToken and accessToken are optional but at least one must be present');
        }
        return ({
            provider: this.PROVIDER_ID,
            idToken: idToken,
            accessToken: accessToken
        });
    };
    Object.defineProperty(GoogleAuthProvider.prototype, "providerId", {
        get: function () {
            return GoogleAuthProvider.PROVIDER_ID;
        },
        enumerable: true,
        configurable: true
    });
    return GoogleAuthProvider;
}());

GoogleAuthProvider.PROVIDER_ID = 'google.com';
var TwitterAuthProvider = (function () {
    function TwitterAuthProvider() {
    }
    TwitterAuthProvider.credential = function (token, secret) {
        return ({
            provider: this.PROVIDER_ID,
            token: token,
            secret: secret
        });
    };
    Object.defineProperty(TwitterAuthProvider.prototype, "providerId", {
        get: function () {
            return TwitterAuthProvider.PROVIDER_ID;
        },
        enumerable: true,
        configurable: true
    });
    return TwitterAuthProvider;
}());

TwitterAuthProvider.PROVIDER_ID = 'twitter.com';


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generatePushKey;
/**
 * The characters used to generate the push IDs.
 * See: https://gist.github.com/mikelehen/3596a30bd69384624c11
 */
var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
var lastTime = 0;
var lastRandChars = [];
/**
 * Based on the code provided by Michael Lehenbauer: https://gist.github.com/mikelehen/3596a30bd69384624c11
 * Also see: https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html
 *
 * @param timeDiff
 * @returns {string}
 * @internal
 */
function generatePushKey(timeDiff) {
    if (timeDiff === void 0) { timeDiff = 0; }
    var now = Date.now() - timeDiff; //this.db.timeDiff;
    var isDuplicateTime = (now === lastTime);
    lastTime = now;
    var timeStampChars = new Array(8);
    for (var i = 7; i >= 0; i--) {
        timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
        // NOTE: Can't use << here because javascript will convert to int and lose the upper bits.
        now = Math.floor(now / 64);
    }
    if (now !== 0)
        throw new Error('generatePushId: We should have converted the entire timestamp.');
    var id = timeStampChars.join('');
    if (!isDuplicateTime) {
        for (var i = 0; i < 12; i++) {
            lastRandChars[i] = Math.floor(Math.random() * 64);
        }
    }
    else {
        // If the timestamp hasn't changed since last push, use the same random number, except incremented by 1.
        var i = void 0;
        for (i = 11; (i >= 0) && (lastRandChars[i] === 63); i--) {
            lastRandChars[i] = 0;
        }
        lastRandChars[i]++;
    }
    for (var i = 0; i < 12; i++) {
        id += PUSH_CHARS.charAt(lastRandChars[i]);
    }
    if (id.length != 20)
        throw new Error('generatePushKey: Length should be 20.');
    return id;
}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("cordova/exec");

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js